import './CTGY.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import {Search} from 'custom-extensions/searchspring';

export default class CTGY extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initSearch();
		this.initReadMore();
	}

	/**
	 * Initialize Search UI
	 */
	initSearch () {
		const bgFilters = [];

		if (typeof this.pageContext.Category_Option === 'string' && this.pageContext.Category_Option !== '') {
			this.pageContext.Category_Option.split('|').forEach((option) => {
				bgFilters.push({
					name: 'available_options',
					value: option.trim()
				});
			});
		}

		Search.create({
			bgFilters,
			categoryCode: this.pageContext.Category_Hierarchy,
			categoryField: 'hierarchy',
			defaultSearchParams: {
				resultsPerPage: 24
			},
			query: this.pageContext.Search,
			siteId: this.pageContext.SS_Site_ID
		});
	}

	async initReadMore () {
		const readMoreContainer = document.getElementsByClassName('g-read-more')[0];

		if (!readMoreContainer) {
			return;
		}

		const {ReadMore} = await import('custom-extensions/read-more');

		new ReadMore();
	}
}
